class ConnectionRule {
    static get DAY_VALUE() { return [1,2,4,8,16,32,64]; }

    constructor() {
        this._rowElem = null;
        this._appliedCheckbox = chk(null, null, null, {'change' : this.apply.bind(this)});

        this._id = 0;
        this._name = _("New rule");
        this._startDate = null;
        this._endDate = null;
        this._days = 127;
        this._startTimes = 8*60;
        this._endTimes = 18*60;
    }

    static fromArray(data) {
        let inst = new ConnectionRule();

        inst._id = data.shift();
        inst._name = data.shift();
        inst._startDate = data.shift() * 1000;
        inst._endDate = data.shift() * 1000;
        inst._days = data.shift();
        inst._startTimes = data.shift();
        inst._endTimes = data.shift();     
        
        return inst;
    }

    update() {
        this.nameElem.innerHTML = this._name;
    }

    get rowElem() {
        if (this._rowElem === null) this._rowElem = div('tooltip', [
                this._appliedCheckbox,
                this.nameElem = span(null, this._name),
				span(null, icon('edit', 'sm'), { 'click' : this.edit.bind(this)})
            ], null, {'data-tip': 'Description of the rule'}
        );

        return this._rowElem;
    }

    get name() {return this._name;}

    set name(value) {this._name = value;}

    get startDate() {return this._startDate;}

    set startDate(value) {this._startDate = value;}

    get endDate() {return this._endDate;}

    set endDate(value) {this._endDate = value;}

    get days() {return this._days;}

    set days(value) {this._days = value;}

    get startTimes() {
        return Array.isArray(this._startTimes) ? this._startTimes.split(/,/) : this._startTimes;
    }

    /**
     * @param {Array} values
     */
    set startTimes(value) {
        this._startTimes = Array.isArray(value) ? value.join(',') : value;
        return this;
    }

    get endTimes() {
        return Array.isArray(this._endTimes) ? this._endTimes.split(/,/) : this._endTimes;
    }

    /**
     * @param {Array} values
     */
    set endTimes(value) {
        this._endTimes = Array.isArray(value) ? value.join(',') : value;
        return this;
    }

    edit() {
        if (typeof connectionRules === 'object' && connectionRules instanceof ConnectionRuleList) {
            connectionRules.editRule(this);
        }
    }

    save() {
        ajp('rules/save', [
            'id=' + this._id,
            'name=' + encodeURI(this._name),
            'startDate=' + this._startDate / 1000,
            'endDate=' + this._endDate / 1000,
            'days=' + this._days,
            'startTimes=' + this._startTimes,
            'endTimes=' + this._endTimes
        ], null, function(reply){
                if (reply._id) {
                    this._id = reply._id;
                }
                if (reply.toast) {
                    makeToast(reply.toast);
                }
                this.update();
            }, this
        )
    }

    /**
     * Toggle the application of this rule to the currently mapped user
     */
    apply() {
        if (
            typeof connectionRules === 'undefined' || 
            !connectionRules instanceof ConnectionRuleList ||
            connectionRules.mappedUser === null
        ) return;

        ajg('rules/apply', [
            'id=' + this._id,
            'userId=' + connectionRules.mappedUser,
            'value=' + (this._appliedCheckbox.checked ? 1 : 0)
        ])
    }
}